var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-toolbar",class:{'action-toolbar--sticky':_vm.sticky,
              'action-toolbar--no-border': !_vm.border}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }